(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/game-list/assets/javascripts/game-status.js') >= 0) return;  svs.modules.push('/components/marketplace/game-list/assets/javascripts/game-status.js');

'use strict';

const {
  format
} = svs.utils;
const {
  gamesConstants
} = svs.components.marketplaceData;
const {
  newLineToBreak
} = svs.components.lbUi;
const {
  applyNewLine
} = svs.components.marketplace.gameList.helpers;
const {
  ReactIcon
} = svs.ui;
const GameStatus = _ref => {
  let {
    gameStatus,
    drawHasClosed,
    fractionsCount,
    fractionPrice,
    hasBoughtFractions,
    hasPermissionToSubmit,
    isRetail,
    isSoldOut,
    preliminaryRowExists
  } = _ref;
  const hasStatus = status => gameStatus === status;
  const classNamesWithMatch = [{
    className: 'fc-navy',
    isMatching: hasStatus(gamesConstants.GAME_STATUS_OPEN) && !hasBoughtFractions
  }, {
    className: 'fc-navy',
    isMatching: hasStatus(gamesConstants.GAME_STATUS_OPEN) && hasBoughtFractions && !isSoldOut
  }, {
    className: 'fc-red',
    isMatching: (hasStatus(gamesConstants.GAME_STATUS_SUBMITTABLE) || hasStatus(gamesConstants.GAME_STATUS_NOT_ENOUGH_SOLD)) && !drawHasClosed && hasPermissionToSubmit
  }, {
    className: 'fc-navy',
    isMatching: true
  }];
  const resolveClassName = () => classNamesWithMatch.find(className => className.isMatching).className;
  const resolveStatusLabel = () => {
    if (isRetail) {
      const price = format.Currency(fractionPrice);
      return price ? "".concat(price, " kr") : '-';
    }
    const cost = format.Currency(fractionPrice * fractionsCount);
    return parseInt(cost, 10) ? "".concat(cost, " kr") : '';
  };
  const renderPreliminaryRow = () => {
    if (preliminaryRowExists) {
      return React.createElement("div", null, React.createElement(ReactIcon, {
        icon: "overview",
        size: "100"
      }));
    }
    return React.createElement("div", null);
  };
  const getStatus = () => ({
    label: resolveStatusLabel(),
    className: resolveClassName()
  });
  const status = getStatus();
  return React.createElement("div", {
    className: "game-status f-uppercase f-400 f-right ".concat(status.className),
    "data-testid": "qa-game-status"
  }, renderPreliminaryRow(), React.createElement("div", null, newLineToBreak(applyNewLine(status.label, 6))));
};
GameStatus.defaultProps = {
  drawHasClosed: false,
  fractionPrice: 0,
  gameStatus: '',
  hasBoughtFractions: false,
  hasPermissionToSubmit: false,
  isSoldOut: false
};
setGlobal('svs.components.marketplace.gameList.GameStatus', GameStatus);

 })(window);